import type { MarketingCampaignFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (
	serverModel: ServerModel,
): MarketingCampaignFormModel["InputModel"] => {
	const { voucherForCampaign } = serverModel;

	const inputModel: MarketingCampaignFormModel["InputModel"] = {
		hotelID: voucherForCampaign.hotelID,
		voucherID: voucherForCampaign.voucherID,

		inSale: voucherForCampaign.inSale,

		name: voucherForCampaign.name,
		description: voucherForCampaign.description,

		mainKeyVisual: voucherForCampaign.mainKeyVisual,

		voucherPrice: voucherForCampaign.voucherPrice,
		resourceAvailablePrice: voucherForCampaign.resourceAvailablePrice,

		mailTemplate: voucherForCampaign.mailTemplate,
		voucherExplanationForHost: voucherForCampaign.voucherExplanationForHost,
		voucherGiftList: voucherForCampaign.voucherGiftList.map((item) => {
			return {
				guestEmail: item.guestEmail || "",
				guestName: item.guestName,
				guestTel: item.guestTel || "",
			};
		}),

		cinStart: voucherForCampaign.cinStart,
		cinEnd: voucherForCampaign.cinEnd,
	} satisfies MarketingCampaignFormModel["InputModel"];

	return inputModel;
};
